import React from 'react';
var WidthContext = React.createContext({ width: 600 });
export var WidthProvider = WidthContext.Provider;
export var useWidth = function () { return React.useContext(WidthContext); };
export var useRemainingWidth = function (_a) {
    var border = _a.border, borderLeft = _a.borderLeft, borderRight = _a.borderRight, padding = _a.padding, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, round = _a.round, width = _a.width;
    var availableWidth = useWidth().width;
    return React.useMemo(function () {
        var adjustedWidth = availableWidth;
        if (width === null || width === void 0 ? void 0 : width.endsWith('%')) {
            adjustedWidth = (availableWidth * parseFloat(width)) / 100;
        }
        else if (width === null || width === void 0 ? void 0 : width.endsWith('px')) {
            adjustedWidth = parseInt(width, 10);
        }
        var paddingList = (padding || '').split(' ');
        var paddingLeftValue = parseInt(paddingLeft || paddingList[3] || paddingList[1] || paddingList[0] || '0', 10);
        var paddingRightValue = parseInt(paddingRight || paddingList[1] || paddingList[0] || '0', 10);
        var borderLeftValue = extractWidthInPixels(borderLeft || border, 0);
        var borderRightValue = extractWidthInPixels(borderRight || border, 0);
        var result = Math.max(adjustedWidth -
            paddingLeftValue -
            paddingRightValue -
            borderLeftValue -
            borderRightValue, 0);
        return {
            width: round ? Math.floor(result) : result,
        };
    }, [
        width,
        availableWidth,
        padding,
        paddingLeft,
        paddingRight,
        border,
        borderLeft,
        borderRight,
        round,
    ]);
};
function extractWidthInPixels(cssValue, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    var valueWithPx = (cssValue || '').split(' ').find(function (_) { return _.includes('px'); });
    return parseInt(valueWithPx, 10) || defaultValue;
}
//# sourceMappingURL=width-context.js.map